import React from 'react';
import { Body, Title } from 'scy/text';
import { AccentBackground } from 'scy/Background';
import StarRating from './StarRating';
import margin from 'scy/margin.mod.scss';
import { tablet_inlineBlock } from 'scy/display.mod.scss';
import styles from './RatingsOverview.mod.scss';
import { pluralize } from 'shared/utils';

export default function RatingsOverview({ count, average, histogram }) {
  const averageDisplay = Number.parseFloat(average).toFixed(2);
  return !count ? null : (
    <>
      <Body marginClass={`${margin.top_0} ${margin.bottom_sm}`}>
        Ratings overview
      </Body>
      <div className={styles.container}>
        <Box average={averageDisplay} total={count} />
        <Histogram counts={histogram} total={count} />
      </div>
    </>
  );
}

function Box({ average, total }) {
  const averageDisplay = Number.parseFloat(average).toFixed(2);
  return (
    <AccentBackground className={styles.box}>
      <Title className={tablet_inlineBlock}>{averageDisplay}</Title>
      <div
        className={`${margin.bottom_xxs} ${
          margin.tablet_left_xs
        } ${tablet_inlineBlock}`}
      >
        <StarRating rating={averageDisplay} />
        <div>
          {total} {pluralize('Review', total)}
        </div>
      </div>
    </AccentBackground>
  );
}

function Histogram({ counts, total }) {
  if (counts == null || total == null) return null;

  return (
    <dl className={styles.histogram}>
      <HistogramRow rating={5} count={counts[5]} total={total} />
      <HistogramRow rating={4} count={counts[4]} total={total} />
      <HistogramRow rating={3} count={counts[3]} total={total} />
      <HistogramRow rating={2} count={counts[2]} total={total} />
      <HistogramRow rating={1} count={counts[1]} total={total} />
    </dl>
  );
}

function HistogramRow({ rating, count, total }) {
  return (
    <>
      <dt className={styles.histogramRating}>
        {rating} {pluralize('star', rating)}
      </dt>
      <dd className={styles.histogramCount}>
        <div className={styles.histogramBarBackground}>
          <div
            className={styles.histogramBar}
            style={{ width: `${100 * (count / total)}%` }}
          />
        </div>
        <span className={margin.left_xxs}>{count}</span>
      </dd>
    </>
  );
}
